module.exports = __webpack_public_path__ + "img/emoji_10.a8b55347.png";